import { axios } from '../../shared/axios';
import { actionNotifier } from '../../components/tostify';
const LOCAL_STORAGE_TOKEN = '99GIFT';

export const getToken = () => {
    let auth = localStorage.getItem(LOCAL_STORAGE_TOKEN);

    if (auth) {
        const data = JSON.parse(auth);
        return data?.token;
        // return myToken;
    } else {
        return null;
        // return myToken;
    }
};

export const apiFunction = async (url, method, postData, token, extraConfig) => {
    let config = {
        method,
        url,
        data: postData || {},
    };

    // 🔐 Token handling (unchanged behavior)
    if (token) {
        const authToken = getToken();
        config.headers = {
            Authorization: `Bearer ${authToken}`,
        };
    }

    // 📦 Blob support
    if (extraConfig === 'blob') {
        config.responseType = 'blob';
    }

    // 📎 Multipart support
    if (extraConfig === 'multipart') {
        config.headers = {
            ...config.headers,
            'content-type': 'multipart/form-data',
        };
    }

    try {
        const apiResponse = await axios(config);

        if (apiResponse?.status === 401 || apiResponse?.status === 404) {
            userLogout();
            actionNotifier.error('Please login again', { position: 'top-right', autoClose: 2000 });
            throw new Error('Please login again');
        }

        if (apiResponse?.status === 503) {
            actionNotifier.error('Service Unavailable - try again later', {
                position: 'top-right',
                autoClose: 2000,
            });
        }

        return {
            success: true,
            status: true,
            message: apiResponse?.data?.message || 'Success',
            statusCode: apiResponse.status,
            ...apiResponse.data,
        };
    } catch (err) {
        const statusCode = err?.response?.status || 500;
        if (statusCode === 401 || statusCode === 404) {
            userLogout();
            actionNotifier.error('Please login again', { position: 'top-right', autoClose: 2000 });
            return;
        }

        return {
            success: false,
            status: false,
            message: err?.response?.data?.message || err.message || 'Something went wrong',
            statusCode,
            ...(err?.response?.data || null),
        };
    }
};

export const postFormDataAPI = async (url, postData, section) => {
    let token = getToken(section);
    let data;
    const config = {
        headers: {
            'content-type': 'multipart/form-data',
            token: `${token}`,
        },
    };
    await axios
        .post(url, postData, config)
        .then((res) => {
            data = res.data;
        })
        .catch((err) => {
            data = {
                ...err.response.data,
                status: false,
            };
        });
    return data;
};

export const userTokenSave = (token) => {
    if (token) {
        localStorage.setItem(LOCAL_STORAGE_TOKEN, JSON.stringify({ token }));
        return true;
    }
    return false;
};

export const userLogout = (timer = 2000) => {

    return;
    actionNotifier.clearAll();

    const token = localStorage.getItem(LOCAL_STORAGE_TOKEN);
    if (token) {
        localStorage.removeItem(LOCAL_STORAGE_TOKEN);
    }

    setTimeout(() => {
        window.location.reload(); // Reload page to log out completely
    }, timer);
};
